/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { APP_BASE_HREF } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ExtNotFoundPageComponent } from '@gh/common-external-shared';
import { createRoute } from '@gh/common-shared';
import {
  SupplierCalendarComponent,
  SupplierInvoicesListComponent,
  SupplierPurchaseOrderListComponent,
  SupplierSharedDocsListComponent,
} from './components';
import { SupplierOfficeActivator } from './resources';
import { getSupplierBootstrapParams } from './supplier-app.utils';

const routes: Routes = [{
  path: 'accept-invitation/:officeId',
  canActivate: [SupplierOfficeActivator],
  data: {
    isAcceptInvitation: true,
  },
  // empty children is necesary here to workaround @angular/router problem:
  // it does not allow to use route without component/children/loadChildren/redirectTo
  // it is not a problem here, as we never load this route (CanActivate always return false)
  children: [],
}, {
  path: '',
  pathMatch: 'full',
  canActivate: [SupplierOfficeActivator],
  children: [],
}, {
  path: 'offices/:officeId',
  canActivate: [SupplierOfficeActivator],
  runGuardsAndResolvers: 'always',
  children: [
    createRoute({
      path: 'purchase-orders',
      pathMatch: 'full',
      component: SupplierPurchaseOrderListComponent,
    }),
    createRoute({
      path: 'shared-docs',
      pathMatch: 'full',
      component: SupplierSharedDocsListComponent,
    }),
    createRoute({
      path: 'calendar',
      pathMatch: 'full',
      component: SupplierCalendarComponent,
    }),
    createRoute({
      path: 'invoices',
      pathMatch: 'full',
      component: SupplierInvoicesListComponent,
    }),
  ],
}, {
  path: '404',
  component: ExtNotFoundPageComponent,
}, {
  path: '**',
  component: ExtNotFoundPageComponent,
}];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  providers: [{
    provide: APP_BASE_HREF,
    useValue: getSupplierBootstrapParams().baseUrl,
  }],
  declarations: [],
  exports: [RouterModule],
})
export class SupplierAppRoutingModule {
}
